const sellerProductConvertToMarketProductFormInitialValues = (product) => ({
  price_offer: product?.price || 0
})

export default sellerProductConvertToMarketProductFormInitialValues
